import { render, staticRenderFns } from "./bank-account.vue?vue&type=template&id=ee8a235e&scoped=true"
import script from "./bank-account.vue?vue&type=script&lang=js"
export * from "./bank-account.vue?vue&type=script&lang=js"
import style0 from "./bank-account.vue?vue&type=style&index=0&id=ee8a235e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8a235e",
  null
  
)

export default component.exports